module.exports = __webpack_public_path__ + "static/img/reddit.71f63bbc.png";